module.exports = __webpack_public_path__ + "static/media/erik-lucatero-1.48eb01ff.jpg";